import { useState, useCallback, useRef, useEffect } from 'react';
import { GetCommunicationsAPI } from './CommunicationsAPI';

export const useFetchCommunications = () => {
  const [loading, setLoading] = useState(true);
  const [communications, setCommunications] = useState([]);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const getCommunications = useCallback(async token => {
    const data = await GetCommunicationsAPI(token);

    if (!isMountedRef.current) {
      return;
    }

    if (data.success) {
      let sortedData = data.data.data.data.sort(
        (a, b) => a.position - b.position
      );

      let gameCommunication = null;

      sortedData.forEach(communication => {
        if (communication.game) {
          gameCommunication = communication;
        }
      });

      sortedData = sortedData.filter(communication => !communication.game);

      // Game communications are shown to all users (authenticated or not) so that
      // unauthenticated users can see the campaign banner and the conditions they need to meet.
      if (gameCommunication) {
        setCommunications([gameCommunication, ...sortedData]);
        setLoading(false);
        return;
      }

      setCommunications(sortedData);
    }

    setLoading(false);
  }, []);

  return [communications, getCommunications, loading];
};
